import { ActionDialog, Notification } from "@/components"
import { Grid, Typography } from "@material-ui/core"
import React, { useState } from "react"
import { UserInstance } from "@/services/User"
import InstanceListItem, { InstanceListItemView } from "@/components/InstanceSelectorDialogue/InstanceListItem"
import { useGlobalStateStore } from "@/store/GlobalState"
import ApiService from "@/services/Api"
import { TagDataProps } from "@/protocols/clientCatalog"

type EnrichedUserInstance = UserInstance & {
	viewType: InstanceListItemView
}

type ImportTagsDialogProps = {
	onChange: (tags: TagDataProps[]) => void
	disabled?: boolean
}

type InstancesRelatedToImportData = {
	sourceInstance: {
		id?: number
		name?: string
	}
	targetInstance: {
		id?: number
		name?: string
	}
}

const ImportTagsDialog: React.FC<ImportTagsDialogProps> = (props) => {
	const { children, onChange, disabled } = props

	const globalStateStore = useGlobalStateStore()
	const allUserInstances = globalStateStore.user.user_instances

	const [openDialog, setOpenDialog] = useState(false)
	const [openConfirmImportDialog, setOpenConfirmImportDialog] = useState(false)
	const [instancesData, setInstancesData] = useState<InstancesRelatedToImportData>()

	const importTagsText = `Tem certeza que deseja importar todas as tags da instância ${instancesData?.targetInstance.id} | ${instancesData?.targetInstance.name} para a instância ${instancesData?.sourceInstance.id} | ${instancesData?.sourceInstance.name}?`

	const handleOpenImportTagsDialog = () => {
		setOpenDialog(true)
	}

	const handleCloseImportTagsDialog = () => {
		setOpenDialog(false)
	}

	const handleOpenConfirmImportTagsDialog = () => {
		setOpenConfirmImportDialog(true)
	}

	const handleCloseConfirmImportTagsDialog = () => {
		setOpenConfirmImportDialog(false)
	}

	const getEnrichedUserInstances = (userInstances: UserInstance[]): EnrichedUserInstance[] => {
		const enrichedUserInstances: EnrichedUserInstance[] = userInstances.map((userInstance) => {
			return {
				...userInstance,
				viewType: "import_instance_tag_item"
			}
		})

		return enrichedUserInstances
	}

	const enrichedUserInstances = getEnrichedUserInstances(allUserInstances)

	const importTags = async () => {
		try {
			const { data } = await ApiService.post(`/tag/import/${instancesData?.sourceInstance.id}`)

			if (data.length === 0) {
				Notification.warning({ message: "Não há tags a serem importados." })
			} else {
				onChange(data)
				Notification.success({ message: "Tags importadas com sucesso." })
			}
		} catch (error) {
			Notification.error({ message: "Não foi possível importar as tags." })
		}
		handleCloseImportTagsDialog()
		handleCloseConfirmImportTagsDialog()
	}

	const handleOpenConfirmationDialog = (sourceInstanceId: number, targetInstanceName?: string) => {
		const sourceInstanceName = globalStateStore.instance?.nickname

		setInstancesData({
			sourceInstance: {
				id: sourceInstanceId,
				name: sourceInstanceName
			},
			targetInstance: {
				id: globalStateStore.instance.instance_id,
				name: String(targetInstanceName)
			}
		})

		handleOpenConfirmImportTagsDialog()
	}

	return (
		<>
			<Grid item onClick={!disabled && handleOpenImportTagsDialog}>
				{children}
			</Grid>
			<ActionDialog
				title="Importar Tags"
				openDialog={openDialog}
				onClose={handleCloseImportTagsDialog}
			>
				<Grid
					container
					spacing={1}
				>
					{enrichedUserInstances.map((userInstance, userInstanceIndexPositionOnArray) => {
						if (userInstance.instance_id !== globalStateStore.instance.instance_id) {
							return (
								<Grid
									item
									xs={12}
									key={userInstanceIndexPositionOnArray}
								>
									<InstanceListItem
										targetInstanceId={userInstance.instance_id}
										targetInstanceName={String(userInstance.nickname)}
										targetInstanceRoleName={userInstance.user_role_name}
										listedView={userInstance.viewType}
										onClick={() => handleOpenConfirmationDialog(userInstance.instance_id, String(userInstance.nickname))}
									/>
								</Grid>
							)
						}
					})}
				</Grid>
			</ActionDialog>
			<ActionDialog
				title="Importar Tags"
				openDialog={openConfirmImportDialog}
				onSave={importTags}
				saveText="IMPORTAR"
				onClose={handleCloseConfirmImportTagsDialog}
			>
				<Grid container spacing={2}>

					<Grid item>
						<Typography>
							{importTagsText}
						</Typography>
					</Grid>
					<Grid item>
						<Grid container direction="column" spacing={1}>
							<Grid item>
								<Typography style={{ fontWeight: 700 }}>
									ATENÇÃO:
								</Typography>
							</Grid>
							<Grid item>
							A importação será feita com base no nome das tags, ignorando letras maiúsculas e minúsculas. Caso exista alguma tag com nome exatamente igual entre as instâncias, <strong>a tag não será importada.</strong>
							</Grid>
						</Grid>
					</Grid>
				</Grid>
			</ActionDialog>
		</>
	)
}

export default ImportTagsDialog
